// RolePill — coloured pill for the v2 user-role enum (spec 44).
// Roles per Batch 4.5: Marketing collapsed into Editor.

export type UserRole = 'volunteer' | 'editor' | 'manager' | 'finance' | 'admin';

const ROLE_STYLES: Record<UserRole, string> = {
  volunteer: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  editor: 'bg-amber-50 text-amber-900 border-amber-200',
  manager: 'bg-sky-50 text-sky-800 border-sky-200',
  finance: 'bg-violet-50 text-violet-800 border-violet-200',
  admin: 'bg-rose-50 text-rose-800 border-rose-200',
};

const ROLE_LABELS: Record<UserRole, string> = {
  volunteer: 'Volunteer',
  editor: 'Editor',
  manager: 'Manager',
  finance: 'Finance',
  admin: 'Admin',
};

export interface RolePillProps {
  role: UserRole;
  /** Render the dot prefix (default true). */
  withDot?: boolean;
  className?: string;
}

export function RolePill({ role, withDot = true, className = '' }: RolePillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold ${ROLE_STYLES[role]} ${className}`}
      data-component="role-pill"
      data-role={role}
    >
      {withDot && (
        <span
          aria-hidden
          className="h-1.5 w-1.5 rounded-full bg-current opacity-70"
        />
      )}
      {ROLE_LABELS[role]}
    </span>
  );
}

export const USER_ROLES: readonly UserRole[] = [
  'volunteer',
  'editor',
  'manager',
  'finance',
  'admin',
] as const;
